import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, Inject, inject, PLATFORM_ID } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { KbCheckOutService } from 'src/app/services/feature/CheckOut/kb-check-out.service';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';

@Component({
  selector: 'app-quick-order-nav',
  templateUrl: './quick-order-nav.component.html',
  styleUrls: ['./quick-order-nav.component.scss'],
  standalone: false
})
export class QuickOrderNavComponent {
  private scrollSub!: Subscription;
  subscription = new Subscription();
  constructor(private custIdService: CustomerIdService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }
  onlineOrdering$ = this.custIdService.onlineOrdering$;
  isOrderBlocked$ = this.custIdService.isOrderBlocked$;
  checkoutService = inject(KbCheckOutService);
  cdr = inject(ChangeDetectorRef);
  isCheckoutPage: boolean = false;
  showContent: boolean = false;
 

  ngOnInit() {
    this.subscription.add(this.checkoutService.isCheckOut$.subscribe((isItCheckoutPage) => {
      if (isItCheckoutPage) {
        this.isCheckoutPage = isItCheckoutPage;
      } else {
        this.isCheckoutPage = false;
      }
      this.cdr.detectChanges();
    }));

    if (isPlatformBrowser(this.platformId)) {
      this.subscription.add(this.scrollSub = fromEvent(window, 'scroll').subscribe(() => {
        this.showContent = false;
      }));
    }

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.scrollSub) {
      this.scrollSub.unsubscribe();
    }
  }
}
